// @ts-ignore
import styled from "styled-components/macro";
import InlineSVG from "react-inlinesvg";

interface StickyButtonProps {
  text: string;
  variant?: "go-button" | "no-button";
  size?: "default" | "small";
  onClick: () => void;
  className?: string;
}

const StickyButtonContainer = styled.button`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  background: white;
  font-family: "GT Super Text";
  font-weight: 700;
  font-size: 28px;
  border-radius: 50px;
  padding: 0 16px;
  cursor: pointer;


  &.go-button {
    bottom: 16px;
    left: 50%;
    color: var(--primary-cta);
    border: 1px solid var(--primary-cta);
    box-shadow:
    0 0 0 4px white,
    0 0 4px 4.5px rgba(0, 0, 0, 0.15);
    rotate: 2deg;
    transition:
      left 0.5s ease-out;

    &:hover {
      left: 55%;
      transition:
        left 0.1s ease-out,
        bottom 0.1s ease-out;
    }
  }

  &.no-button {
    --background-screen: rgba(255, 255, 255, 0.92);
    background: linear-gradient(var(--background-screen), var(--background-screen)), url("/assets/crinkled-paper.jpg");
    background-size: 140%;
    gap: 4px;
    font-size: 20px;
    padding: 8px 10px;
    border: none;
    color: #383838CC;
    bottom: 16px;
    left: -3%;
    box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.15);
    rotate: -3deg;
    transition:
      left 0.15s ease-out,
      bottom 0.15s ease-out;

    &:hover {
      left: -7%;
      bottom: 14px;
      transition:
        left 0.4s ease-out,
        bottom 0.4s ease-out;
    }

    &.small:hover {
      left: 48%;
      bottom: 8px;
    }
  }


  &.small {
    font-size: 18px;
    bottom: 10px;
    padding: 4px 10px;
    left: 50%;
    transform: translateX(-50%);
    rotate: 0deg;

    svg {
      width: 20px !important;
      height: 20px !important;
    }
  }
`;

export function StickyButton({ text, variant = "go-button", size = "default", onClick, className = "" }: StickyButtonProps) {
  return (
    <StickyButtonContainer
      className={`use-component-styles ${variant} ${size} ${className}`}
      onClick={onClick}
    >
      {variant === "no-button" && (
        <InlineSVG
          className="inline-block w-[20px] h-[20px] align-middle"
          src="/assets/back-fancy.svg"
        />
      )}
      {text}
      {variant === "go-button" && (
        <InlineSVG
          className="inline-block w-[36px] h-[36px] align-middle mt-1"
          src="/assets/point.svg"
        />
      )}
    </StickyButtonContainer>
  );
}
